var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBscLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8826 24.912V28.2762L14.9493 30L12.0995 28.2762V24.912L14.9493 26.6358L17.8826 24.912ZM2.1875 13.2762L5.03736 15V20.7692L9.94468 23.7025V27.0667L2.1875 22.493V13.2762ZM27.7111 13.2762V22.5069L19.8705 27.0806V23.7164L24.7779 20.7831V15.0139L27.7111 13.2762ZM19.8566 8.7025L22.7899 10.4263V13.7905L17.8826 16.7238V22.5765L15.0327 24.3003L12.1968 22.5765V16.7099L7.10872 13.7766V10.4124L10.042 8.6886L14.9493 11.6219L19.8566 8.7025ZM7.10872 16.1956L9.95858 17.9194V21.2836L7.10872 19.5598V16.1956ZM22.7899 16.1956V19.5598L19.94 21.2836V17.9194L22.7899 16.1956ZM5.03736 5.76923L7.97063 7.49305L5.03736 9.21686V12.5811L2.1875 10.8573V7.49305L5.03736 5.76923ZM24.8613 5.76923L27.7945 7.49305V10.8573L24.8613 12.5811V9.21686L22.0114 7.49305L24.8613 5.76923ZM14.9493 5.76923L17.8826 7.49305L14.9493 9.21686L12.0995 7.49305L14.9493 5.76923ZM14.9493 0L22.7899 4.57368L19.94 6.2975L15.0327 3.36422L10.0281 6.2975L7.17823 4.57368L14.9493 0Z",
    fill: "#F3BA2F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscLogo);
export default __webpack_public_path__ + "static/media/bsc-logo.609ca7c1b21028212790da3c5ea71736.svg";
export { ForwardRef as ReactComponent };